import {
  STORE_DESIGN_YOUR_STORE_VIBES,
  STORE_PROGRESSIVE_STYLE_PREVIEW_BY_VIBE,
  STORE_PROGRESSIVE_STYLE_PREVIEW_DESIGN_SRC,
} from '../constants/storeCheckoutAi.constants';

export interface IProgressiveStylePreviewUrls {
  front: string;
  back: string;
  design: string;
}

export const getProgressivePreviewUrls = (styleId: string): IProgressiveStylePreviewUrls => {
  const mapped = STORE_PROGRESSIVE_STYLE_PREVIEW_BY_VIBE[styleId];
  const style = STORE_DESIGN_YOUR_STORE_VIBES.find((s) => s.id === styleId);
  const fallback = style?.imageSrc ?? '';

  if (!mapped) {
    return {
      front: fallback,
      back: fallback,
      design: STORE_PROGRESSIVE_STYLE_PREVIEW_DESIGN_SRC,
    };
  }

  return {
    front: mapped.front,
    back: mapped.back,
    design: STORE_PROGRESSIVE_STYLE_PREVIEW_DESIGN_SRC,
  };
};
